export const SET_FILTER_TYPE_USER = 'SET_FILTER_TYPE_USER';
export const setFilterTypeUser = (filterTypeUser) => (
  {
    type: SET_FILTER_TYPE_USER,
    filterTypeUser
  }
);
export const SET_FILTER_ACTIVE_USER = 'SET_FILTER_ACTIVE_USER';
export const setFilterActiveUser = (filterActiveUser) => (
  {
    type: SET_FILTER_ACTIVE_USER,
    filterActiveUser
  }
);
export const SET_FILTER_TEXT_SEARCH_USER = 'SET_FILTER_TEXT_SEARCH_USER';
export const setFilterTextSearchUser = (filterTextSearchUser) => (
  {
    type: SET_FILTER_TEXT_SEARCH_USER,
    filterTextSearchUser
  }
);
export const SET_DATA_USER_FOR_EDIT = 'SET_DATA_USER_FOR_EDIT';
export const setDataUserForEdit = (dataUserForEdit) => (
  {
    type: SET_DATA_USER_FOR_EDIT,
    dataUserForEdit
  }
);

export const SET_MESSAGE_SAVE_STATE = 'SET_MESSAGE_SAVE_STATE';
export const setMessageSaveState = (messageSaveState) => (
  {
    type: SET_MESSAGE_SAVE_STATE,
    messageSaveState
  }
);

export const SET_DATA_DELIVERY_POINT_FOR_EDIT = 'SET_DATA_DELIVERY_POINT_FOR_EDIT';
export const setDataDeliveryPointForEdit = (dataDeliveryPointForEdit) => (
  {
    type: SET_DATA_DELIVERY_POINT_FOR_EDIT,
    dataDeliveryPointForEdit
  }
);
